/* 🤖 this file was generated by script */
export const wiconUpload03 = {
  name: 'upload_03',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12l-4-4m0 0l-4 4m4-4v8m10-4a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
